export default __webpack_public_path__ + "media/c79e5c6f97d9ca99ffae5d6043705645545025cd8b3a1f78f53833415bcc5d97.svg";